/* @flow */
import * as React from 'react';
import { map } from 'lodash';

import BatchRoleCorrectionModalCommon from './BatchRoleCorrectionModalCommon';
import { graphql } from 'react-apollo';

import GET_ORG_USER_AFFILIATIONS_QUERY from './queries/GetOrgAffiliationViewsQuery.gql';

import type { GetOrganizationMembers_organizations_members_members_user } from '../../../components/PeopleList/queries/__generated__/GetOrganizationMembers';

// Stuff that needs to be passed in
type NonLoaderProps = {
  users: GetOrganizationMembers_organizations_members_members_user[],
  onUserRoleSave: () => void,
  organization: {
    +id: Backbone$Id,
    +uuid: string,
  },
};

type Props = NonLoaderProps & {
  // comes from the query
  orgAffiliationViewsByUserId: Object,
  loading: boolean,
};

function BatchRoleCorrectionModalForPeopleListDataContainer(props: Props) {
  const {
    users,
    orgAffiliationViewsByUserId,
    organization,
    loading,
    onUserRoleSave,
    ...others
  } = props;

  const userData = loading
    ? []
    : map(users, u => ({
        user: u,
        orgAffiliationView: orgAffiliationViewsByUserId[u.id],
      }));

  return (
    // $FlowFixMe
    <BatchRoleCorrectionModalCommon
      {...others}
      loading={loading}
      organizationId={parseInt(organization.id, 10)}
      userData={userData}
      onUserRoleSave={onUserRoleSave}
    />
  );
}

const withOrgAffiliationViews = graphql(GET_ORG_USER_AFFILIATIONS_QUERY, {
  options: ({ organization, users }) => {
    return {
      variables: {
        orgUuid: organization.uuid,
        userUuids: map(users, u => u.uuid),
      },
    };
  },
  props: ({ data }) => {
    const orgAffiliationViewsByUserId = {};
    if (data.organizations && data.organizations.length > 0) {
      data.organizations[0].userAffiliations.forEach(oua => {
        orgAffiliationViewsByUserId[oua.user_id] = oua;
      });
    }
    return {
      loading: data.loading,
      orgAffiliationViewsByUserId,
    };
  },
});

export default (withOrgAffiliationViews(
  BatchRoleCorrectionModalForPeopleListDataContainer
): React$ComponentType<NonLoaderProps>);
